export default __webpack_public_path__ + "static/media/linkedin.77413c43.svg";